/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { HIGHCHARTS_DEFAULT_OPTIONS } from '../../../Chart.constants';
import { BarChartProps } from '../BarChart.props';

export const getBarChartSeriesData = ({ seriesData, seriesName }: BarChartProps): Highcharts.Options => {
  const options: Highcharts.Options = { ...HIGHCHARTS_DEFAULT_OPTIONS };

  if (seriesData) {
    options.series = [
      {
        data: seriesData,
        name: seriesName,
        type: 'bar',
      },
    ];
  }

  return options;
};
